import type { Group, LiveEvent } from '@ms/yammer-data/dist/state/types';
import type { LocationDescriptor } from 'history';

import type { StateWithPrevPathname } from './threads';

export type EventReferrer =
  | 'GlammerAttendeeLink'
  | 'GroupFeedBanner'
  | 'DiscoveryFeedBanner'
  | 'Calendar'
  | 'FeedSelectorDropdown'
  | 'Create'
  | 'Notification'
  | 'Unknown';

type EventPageWithQuery = (broadcastId: LiveEvent['broadcastId'], referrer: EventReferrer) => string;
export const eventPageWithQuery: EventPageWithQuery = (broadcastId, referrer) =>
  `${eventPagePathname(broadcastId)}${eventPageSearch(referrer)}`;

type EventPagePathname = (broadcastId: LiveEvent['broadcastId']) => string;
export const eventPagePathname: EventPagePathname = (broadcastId) => `/events/${broadcastId}`;

export const eventMyConversationsPage: EventPagePathname = (broadcastId) => `/events/${broadcastId}/my`;
export const eventInReviewConversationsPage: EventPagePathname = (broadcastId) => `/events/${broadcastId}/in-review`;
export const eventDismissedConversationsPage: EventPagePathname = (broadcastId) => `/events/${broadcastId}/dismissed`;
export const eventPublishedConversationsPage: EventPagePathname = (broadcastId) => `/events/${broadcastId}/published`;
export const eventPublishedQuestionsPage: EventPagePathname = (broadcastId) =>
  `/events/${broadcastId}/published/questions`;
export const eventPublishedUnansweredQuestionsPage: EventPagePathname = (broadcastId) =>
  `/events/${broadcastId}/published/unanswered`;

type EventPageSearch = (referrer: EventReferrer) => string;
export const eventPageSearch: EventPageSearch = (referrer) => `?eventReferrer=${referrer}`;

type EventQuestionPage = (broadcastId: LiveEvent['broadcastId']) => string;
export const eventQuestionsPage: EventQuestionPage = (broadcastId) => `/events/${broadcastId}/questions`;
export const eventUnansweredQuestionsPage: EventQuestionPage = (broadcastId) => `/events/${broadcastId}/unanswered`;

export const eventPageMatchPath = '/events/:broadcastId';
export const townhallEventPublishedConversationsMatchPath = '/broadcasts/:teamsMeetingId/published';

type EventPageWithPreviousPathname = (
  broadcastId: LiveEvent['id'],
  prevPathname: string,
  referrer: EventReferrer
) => LocationDescriptor<StateWithPrevPathname>;
export const eventPageWithPreviousPathname: EventPageWithPreviousPathname = (broadcastId, prevPathname, referrer) => ({
  pathname: eventPagePathname(broadcastId),
  search: eventPageSearch(referrer),
  state: { prevPathname },
});

type EventCreationPage = (groupId: Group['id']) => string;
export const eventCreationPage: EventCreationPage = (groupId) => `/events/new/${groupId}`;

type EventEditingPage = (groupId: Group['id']) => string;
export const eventEditingPage: EventEditingPage = (broadcastId) => `/events/${broadcastId}/edit`;
